<template>
  <v-container fluid>

    <v-card>
      <v-card-title>
        <v-btn color="primary" class="mr-2" dark @click.native="cancelar()" icon="icon">
          <v-icon>arrow_back</v-icon>
        </v-btn>
        <span class="headline">{{titulo}}</span>

        <v-spacer></v-spacer>

          <v-btn to="/admin/empresa/new" router icon="icon">
            <v-icon>add</v-icon>
          </v-btn>
          <v-btn to="/admin/empresa" router  icon="icon">
            <v-icon>list</v-icon>
          </v-btn>
      </v-card-title>

      <form validate v-on:submit.prevent="onSubmit">

      <v-card-text>
        <EmpresaForm :empresa="empresa"> </EmpresaForm>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <div class=""> <v-btn color="secondary" dark ripple @click.native="cancelar()">Cancelar</v-btn></div>
        <div class="pl-3"> <v-btn color="primary" type="submit" dark ripple>Gravar</v-btn></div>
      </v-card-actions>

      </form>

      <v-snackbar
        :timeout="timeoutAlerta"
        :color="tipoAlerta"
        v-model="snackbar">
        {{ textAlerta }}
        <v-btn dark flat @click.native="snackbar = false">Fechar</v-btn>
      </v-snackbar>


    </v-card>
  </v-container>
</template>

<script>

import EmpresaForm from '@/components/EmpresaForm'
import axios from 'axios'

export default {
  name: 'empresa-edit',
  data () {
    return {
      empresa: {},
      titulo: 'Editar Empresa',
      snackbar: false,
      tipoAlerta: '',
      timeoutAlerta: 6000,
      textAlerta: ''
    }
  },
  components: {
    EmpresaForm
  },
  methods: {
    loadModel () {
      var self = this
      axios.get(`/empresas/${this.$route.params.id}`)
      .then(response => {
        self.empresa = response.data
      })
      .catch(e => {
        self.tipoAlerta = 'error'
        self.textAlerta = 'Erro ao carregar empresa'
        self.snackbar = true
      })
    },
    onSubmit () {
      var self = this
      axios.put(`/empresas/${this.empresa.id}`, this.empresa)
      .then(function (response) {
        self.tipoAlerta = 'success'
        self.textAlerta = 'Empresa alterado com sucesso'
        self.snackbar = true
        if (self.empresa.formData) {
          self.uploadEmpresa()
        }
      })
      .catch(e => {
        self.tipoAlerta = 'error'
        self.textAlerta = 'Erro ao alterar empresa'
        self.snackbar = true
      })
    },
    uploadEmpresa () {
      var self = this
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        onUploadProgress: function (progressEvent) {
          var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
          console.log(percentCompleted)
        }
      }
      axios.post(`/empresas/uploadEmpresa/${this.empresa.id}`, this.empresa.formData, config)
      .then(function (response) {
        // self.tipoAlerta = 'success'
        // self.textAlerta = 'Certificado enviado com sucesso'
        // self.snackbar = true
      })
      .catch(e => {
        self.tipoAlerta = 'error'
        self.textAlerta = 'Erro ao enviar Arquivo'
        self.snackbar = true
      })
    },
    cancelar () {
      this.$router.go(-1)
    }
  },
  created () {
    this.loadModel()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// EmpresaEdit.vue?6d2bb592